import { print } from 'graphql';
import {
  getAllOrdersQuery,
  getClosedOrdersQuery,
  getHolidaysByCurrencyQuery,
  getInActiveOrdersQuery,
} from './DashboardQueries';
import {
  getBnySatBaseUrl,
  getBnySatGraphBaseUrl,
  getConfigBaseUrl,
} from '../../services/apiService';
import { apiCall, createApiThunk, graphqlCall } from '../../utils/api';

export const getAllOrdersThunk = createApiThunk('GET_ALL_ORDERS', graphqlCall);
export const getInActiveOrdersThunk = createApiThunk('GET_INACTIVE_ORDERS', graphqlCall);
export const getClosedOrdersThunk = createApiThunk('GET_CLOSED_ORDERS', graphqlCall);
export const getAllDataVisualization = createApiThunk('GET_ALL_DATA_VISUALIZATION', apiCall);
export const onOrderCancelThunk = createApiThunk('ON_ORDER_CANCEL_THUNK', apiCall);
export const getHolidaysThunk = createApiThunk('GET_HOLIDAYS', graphqlCall);

export const getAllOrders = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getAllOrdersQuery());
  dispatch(getAllOrdersThunk({ url, query }));
};

export const getInActiveOrders = (fromDate: string, toDate: string) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getInActiveOrdersQuery(fromDate, toDate));
  return dispatch(getInActiveOrdersThunk({ url, query }));
};

export const getClosedOrders = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getClosedOrdersQuery());
  return dispatch(getClosedOrdersThunk({ url, query }));
};

export const getAllDataVisualizationDetails = (screenId) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/${screenId}`;
  return dispatch(getAllDataVisualization({ url, method: 'GET' }));
};

export const onOrderCancel = (orderId: any, version: number) => (dispatch: AppDispatch) => {
  const url = `${getBnySatBaseUrl()}/v1/bny/trades/${orderId}/${version}/cancel`;
  return dispatch(onOrderCancelThunk({ url, method: 'PUT', data: null }));
};

export const getHolidays = (ccyCode: string, year: string) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getHolidaysByCurrencyQuery(ccyCode, year));
  return dispatch(getHolidaysThunk({ url, query }));
};
